// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ShareURLMakers = require("./ShareURLMakers.bs.js");
var UIKit__BaseDialog = require("../../uikit/reason/molecules/Dialog/UIKit__BaseDialog.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var VisuallyHidden = require("@reach/visually-hidden").default;
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var CopyMarketingProfileLinkButton = require("./CopyMarketingProfileLinkButton.bs.js");
var ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql = require("../../__generated__/ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.bs.js");

var convertFragment = ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ShareAgentMarketingProfileDialog_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ShareAgentMarketingProfileDialog$BaseShareLink(props) {
  return JsxRuntime.jsxs("a", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.children,
                      className: "flex gap-4"
                    }),
                JsxRuntime.jsx(IconV5.make, {
                      icon: "arrow-right",
                      className: "ml-2"
                    })
              ],
              className: "flex justify-between py-4 px-3 hover:bg-zinc-100 rounded-lg text-zinc-700 hover:text-zinc-700 font-semibold",
              href: props.href,
              rel: "noopener noreferrer",
              target: "_blank"
            });
}

var BaseShareLink = {
  make: ShareAgentMarketingProfileDialog$BaseShareLink
};

function ShareAgentMarketingProfileDialog$ShareOnFacebook(props) {
  return JsxRuntime.jsx(ShareAgentMarketingProfileDialog$BaseShareLink, {
              href: ShareURLMakers.makeFacebookShareUrl(props.url),
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(IconV5.make, {
                            icon: "facebook",
                            className: "text-blue-600 h-5 w-5"
                          }),
                      "Share on Facebook"
                    ],
                    className: "flex gap-4"
                  })
            });
}

var ShareOnFacebook = {
  make: ShareAgentMarketingProfileDialog$ShareOnFacebook
};

function ShareAgentMarketingProfileDialog$ShareOnTwitter(props) {
  return JsxRuntime.jsx(ShareAgentMarketingProfileDialog$BaseShareLink, {
              href: ShareURLMakers.makeTwitterShareUrl(props.url),
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(IconV5.make, {
                            icon: "twitter",
                            className: "text-blue-400 w-5 h-5"
                          }),
                      "Share on Twitter"
                    ],
                    className: "flex gap-4"
                  })
            });
}

var ShareOnTwitter = {
  make: ShareAgentMarketingProfileDialog$ShareOnTwitter
};

function makeLinkedInShareUrl(url) {
  return "https://www.linkedin.com/shareArticle?mini=true&url=" + ShareURLMakers.encodeUrl(url);
}

function ShareAgentMarketingProfileDialog$ShareOnLinkedIn(props) {
  return JsxRuntime.jsx(ShareAgentMarketingProfileDialog$BaseShareLink, {
              href: makeLinkedInShareUrl(props.url),
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(IconV5.make, {
                            icon: "linked-in",
                            className: "text-blue-600 w-5 h-5"
                          }),
                      "Share on LinkedIn"
                    ],
                    className: "flex gap-4"
                  })
            });
}

var ShareOnLinkedIn = {
  makeLinkedInShareUrl: makeLinkedInShareUrl,
  make: ShareAgentMarketingProfileDialog$ShareOnLinkedIn
};

function ShareAgentMarketingProfileDialog$ShareViaEmail(props) {
  return JsxRuntime.jsx(ShareAgentMarketingProfileDialog$BaseShareLink, {
              href: ShareURLMakers.makeEmailShareUrl(props.url),
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(IconV5.make, {
                            icon: "email",
                            className: "text-zinc-500 w-5 h-5"
                          }),
                      "Share via email"
                    ],
                    className: "flex gap-4"
                  })
            });
}

var ShareViaEmail = {
  make: ShareAgentMarketingProfileDialog$ShareViaEmail
};

function ShareAgentMarketingProfileDialog$CloseButton(props) {
  var onPress = props.onPress;
  return JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx(VisuallyHidden, {
                      children: "Close"
                    }),
                JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(IconV5.make, {
                            icon: "cancel",
                            size: 12
                          }),
                      "aria-hidden": true,
                      className: "flex"
                    })
              ],
              className: "border-transparent border cursor-pointer rounded-full p-3 hover:border-zinc-100 hover:bg-zinc-100 text-zinc-500 absolute right-4",
              onClick: (function (param) {
                  onPress();
                })
            });
}

var CloseButton = {
  make: ShareAgentMarketingProfileDialog$CloseButton
};

function ShareAgentMarketingProfileDialog(props) {
  var onDismiss = props.onDismiss;
  var marketingProfile = use(props.marketingProfile);
  return JsxRuntime.jsxs(UIKit__BaseDialog.Animated.make, {
              ariaLabel: "Share profile",
              isOpen: props.isOpen,
              onDismiss: onDismiss,
              overlayClassName: "bg-white flex items-end justify-center sm:items-start",
              contentClassName: "!max-w-xl !w-full !p-4 rounded-lg relative !m-0 sm:!mt-32",
              children: [
                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$CloseButton, {
                      onPress: onDismiss
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Share your marketing profile",
                              className: "text-center font-semibold text-lg text-zinc-800"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$ShareOnFacebook, {
                                      url: marketingProfile.publicUrl
                                    }),
                                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$ShareOnTwitter, {
                                      url: marketingProfile.publicUrl
                                    }),
                                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$ShareOnLinkedIn, {
                                      url: marketingProfile.publicUrl
                                    }),
                                JsxRuntime.jsx(ShareAgentMarketingProfileDialog$ShareViaEmail, {
                                      url: marketingProfile.publicUrl
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(CopyMarketingProfileLinkButton.make, {
                                    urlDetails: marketingProfile.urlDetails.fragmentRefs
                                  }),
                              className: "lg:px-4"
                            })
                      ],
                      className: "flex flex-col gap-6"
                    })
              ]
            });
}

var make = ShareAgentMarketingProfileDialog;

exports.Fragment = Fragment;
exports.BaseShareLink = BaseShareLink;
exports.ShareOnFacebook = ShareOnFacebook;
exports.ShareOnTwitter = ShareOnTwitter;
exports.ShareOnLinkedIn = ShareOnLinkedIn;
exports.ShareViaEmail = ShareViaEmail;
exports.CloseButton = CloseButton;
exports.make = make;
/* IconV5 Not a pure module */
